import { defineMessages } from 'react-intl';

export const onlineChunkAuthFailureMessages = defineMessages({
  title: {
    defaultMessage: 'Recording upload interrupted',
    id: 'klRY2a9O0b',
    description: 'Destructive toast title when online chunk upload fails with auth error',
  },
  description: {
    defaultMessage:
      "You're still signed in. Keep recording, or stop and retry when ready.",
    id: 'I1xPcr8BOt',
    description: 'Destructive toast body when online chunk upload fails with auth error',
  },
});
